module.exports = __webpack_public_path__ + "static/media/no-found-notes.5b455ee6.svg";